import React from "react";
import {DatePicker} from "@mui/x-date-pickers";
import {useTranslation} from "react-i18next";


const DateLte = ({dateLte, setDateLte, minDate, ...props}) => {
    const {t} = useTranslation("inputs");

    return <DatePicker label={t("dateLte.label")}
                       value={dateLte}
                       onChange={(newValue) => {
                           if (newValue && !isNaN(newValue.getTime())) {
                               setDateLte(newValue);
                           }
                       }}
                       slotProps={{textField: {variant: "standard", placeholder: t("dateGte.placeholder"), fullWidth: true}}}
                       minDate={minDate}
                       {...props}
    />
}

export default DateLte;